module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.isCommercialOverrideModalVisible) ? _c('commercial-address-override', {
    on: {
      "confirm": _vm.confirmCommercialOverride,
      "cancel": _vm.cancelCommercialOverride
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSuggestedAddressModalVisible) ? _c('address-suggestion') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn-back icon-back bottom-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Go back")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.disableSubmit) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [(_vm.$route.query.retry) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Please verify your information and submit it once more.")])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            User information\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.newUser.userType === 'INVESTOR' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.userType),
      expression: "newUser.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "InvestorOption",
      "id": "InvestorOption",
      "value": "INVESTOR"
    },
    domProps: {
      "checked": _vm._q(_vm.newUser.userType, "INVESTOR")
    },
    on: {
      "__c": function($event) {
        _vm.newUser.userType = "INVESTOR"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "InvestorOption"
    }
  }, [_vm._v("Investor")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.newUser.userType === 'ADVISOR' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.userType),
      expression: "newUser.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "FinancialAdvisorOption",
      "id": "FinancialAdvisorOption",
      "value": "ADVISOR"
    },
    domProps: {
      "checked": _vm._q(_vm.newUser.userType, "ADVISOR")
    },
    on: {
      "click": function($event) {
        _vm.selectAdvisor()
      },
      "__c": function($event) {
        _vm.newUser.userType = "ADVISOR"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "FinancialAdvisorOption"
    }
  }, [_vm._v("Financial Advisor ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.newUser.userType === 'MINOR' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.userType),
      expression: "newUser.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "MinorOption",
      "id": "MinorOption",
      "value": "MINOR"
    },
    domProps: {
      "checked": _vm._q(_vm.newUser.userType, "MINOR")
    },
    on: {
      "__c": function($event) {
        _vm.newUser.userType = "MINOR"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "MinorOption"
    }
  }, [_vm._v("Minor")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.newUser.userType === 'ADMIN' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.userType),
      expression: "newUser.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "AdminOption",
      "id": "AdminOption",
      "value": "ADMIN"
    },
    domProps: {
      "checked": _vm._q(_vm.newUser.userType, "ADMIN")
    },
    on: {
      "click": function($event) {
        _vm.selectAdmin()
      },
      "__c": function($event) {
        _vm.newUser.userType = "ADMIN"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "AdminOption"
    }
  }, [_vm._v("Admin ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.userType),
      expression: "newUser.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "institutionalRepresentative",
      "id": "institutionalRepresentative",
      "value": "INSTITUTIONAL_REPRESENTATIVE"
    },
    domProps: {
      "checked": _vm._q(_vm.newUser.userType, "INSTITUTIONAL_REPRESENTATIVE")
    },
    on: {
      "__c": function($event) {
        _vm.newUser.userType = "INSTITUTIONAL_REPRESENTATIVE"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "institutionalRepresentative"
    }
  }, [_vm._v("Institutional Representative ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.newUser.userType === 'READ_ONLY' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.userType),
      expression: "newUser.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "readOnlyOption",
      "id": "readOnlyOption",
      "value": "READ_ONLY"
    },
    domProps: {
      "checked": _vm._q(_vm.newUser.userType, "READ_ONLY")
    },
    on: {
      "__c": function($event) {
        _vm.newUser.userType = "READ_ONLY"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "readOnlyOption"
    }
  }, [_vm._v("Read-only")])])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.firstName),
      expression: "newUser.firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('FirstName')
    },
    attrs: {
      "type": "text",
      "name": "FirstName",
      "id": "FirstName",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.newUser.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('FirstName')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.lastName),
      expression: "newUser.lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('LastName')
    },
    attrs: {
      "type": "text",
      "name": "LastName",
      "id": "LastName",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.newUser.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('LastName')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), (_vm.newUser.userType == 'ADVISOR') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.organizationName),
      expression: "newUser.organizationName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('CompanyName1')
    },
    attrs: {
      "type": "text",
      "name": "CompanyName1",
      "id": "CompanyName1",
      "placeholder": "Company name"
    },
    domProps: {
      "value": (_vm.newUser.organizationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.organizationName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('CompanyName1')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Company name 2")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.alternateCompanyName),
      expression: "newUser.alternateCompanyName"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('CompanyName2')
    },
    attrs: {
      "type": "text",
      "name": "CompanyName2",
      "id": "CompanyName2",
      "placeholder": "Company name"
    },
    domProps: {
      "value": (_vm.newUser.alternateCompanyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.alternateCompanyName = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.newUser.userType === 'ADMIN') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Company name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.organizationName),
      expression: "newUser.organizationName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "CompanyName",
      "id": "CompanyName",
      "value": "Calvert Impact Capital"
    },
    domProps: {
      "value": (_vm.newUser.organizationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.organizationName = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.newUser.userType === 'ADMIN' || _vm.newUser.userType === 'ADVISOR') ? _c('div', {
    class: {
      'col-md-12': true, 'col-md-6': _vm.newUser.userType === 'ADMIN'
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "availability-check-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('Email')
    },
    attrs: {
      "type": "text",
      "name": "Email",
      "id": "Email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.newUser.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.email = $event.target.value
      }, _vm.emailInput],
      "blur": _vm.checkEmailAvailability
    }
  }), _vm._v(" "), (_vm.emailAvailabilityStatus !== null) ? _c('div', {
    staticClass: "availability-indicator"
  }, [(_vm.emailAvailabilityStatus === 'checking') ? _c('span', {
    staticClass: "fa fa-spinner fa-spin text-info"
  }) : _vm._e(), _vm._v(" "), (_vm.emailAvailabilityStatus === 'available') ? _c('span', {
    staticClass: "fa fa-check text-success"
  }) : _vm._e(), _vm._v(" "), (_vm.emailAvailabilityStatus === 'unavailable') ? _c('span', {
    staticClass: "fa fa-times text-danger"
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.errors.has('Email')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Email')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newUser.userType === 'ADVISOR'),
      expression: "newUser.userType==='ADVISOR'"
    }],
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("CRD number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.CRDnumber),
      expression: "newUser.CRDnumber"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('CRD')
    },
    attrs: {
      "type": "text",
      "name": "CRD",
      "id": "CRD",
      "placeholder": "CRD NUMBER"
    },
    domProps: {
      "value": (_vm.newUser.CRDnumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.CRDnumber = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('CRD')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newUser.userType === 'INVESTOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY'),
      expression: "newUser.userType === 'INVESTOR' || newUser.userType === 'MINOR' || newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || newUser.userType === 'READ_ONLY'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "date-time-input"
    }
  }, [_vm._v("Date of birth")]), _vm._v(" "), _c('div', {
    staticClass: "form-group input-group date birth-field-bottom"
  }, [_c('date-picker', {
    class: {
      'form-control': true, 'form-control-error': _vm.isBirthFieldInvalid
    },
    attrs: {
      "placeholder": "mm/dd/yyyy",
      "id": "date-time-input",
      "name": "date-time-input",
      "wrap": true,
      "config": _vm.dateBirthConfig
    },
    nativeOn: {
      "blur": function($event) {
        _vm.checkDateBirth(_vm.newUser.dateOfBirth)
      }
    },
    model: {
      value: (_vm.newUser.dateOfBirth),
      callback: function($$v) {
        _vm.newUser.dateOfBirth = $$v
      },
      expression: "newUser.dateOfBirth"
    }
  }), _vm._v(" "), _vm._m(7)], 1), _vm._v(" "), (_vm.isBirthFieldInvalid) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ssn"
    }
  }, [_vm._v("Social security number")]), _vm._v(" "), _c('div', {
    staticClass: "availability-check-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.socialSecurityNum),
      expression: "newUser.socialSecurityNum"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('999-99-9999'),
      expression: "'999-99-9999'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "ssn",
      "id": "ssn",
      "placeholder": "000-00-0000"
    },
    domProps: {
      "value": (_vm.newUser.socialSecurityNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.socialSecurityNum = $event.target.value
      }, _vm.ssnInput],
      "blur": _vm.checkSsnAvailability
    }
  }), _vm._v(" "), (_vm.ssnAvailabilityStatus !== null) ? _c('div', {
    staticClass: "availability-indicator"
  }, [(_vm.ssnAvailabilityStatus === 'checking') ? _c('span', {
    staticClass: "fa fa-spinner fa-spin text-info"
  }) : _vm._e(), _vm._v(" "), (_vm.ssnAvailabilityStatus === 'available') ? _c('span', {
    staticClass: "fa fa-check text-success"
  }) : _vm._e(), _vm._v(" "), (_vm.ssnAvailabilityStatus === 'unavailable') ? _c('span', {
    staticClass: "fa fa-times text-danger"
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.errors.has('ssn')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('ssn')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newUser.userType === 'INVESTOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY'),
      expression: "newUser.userType==='INVESTOR' || newUser.userType === 'MINOR' || newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || newUser.userType === 'READ_ONLY'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Primary email "), (_vm.emailRequired) ? _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "availability-check-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('PrimaryEmail')
    },
    attrs: {
      "type": "text",
      "name": "PrimaryEmail",
      "id": "PrimaryEmail",
      "placeholder": "Primary email"
    },
    domProps: {
      "value": (_vm.newUser.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.email = $event.target.value
      }, _vm.emailInput],
      "blur": _vm.checkEmailAvailability
    }
  }), _vm._v(" "), (_vm.emailAvailabilityStatus !== null) ? _c('div', {
    staticClass: "availability-indicator"
  }, [(_vm.emailAvailabilityStatus === 'checking') ? _c('span', {
    staticClass: "fa fa-spinner fa-spin text-info"
  }) : _vm._e(), _vm._v(" "), (_vm.emailAvailabilityStatus === 'available') ? _c('span', {
    staticClass: "fa fa-check text-success"
  }) : _vm._e(), _vm._v(" "), (_vm.emailAvailabilityStatus === 'unavailable') ? _c('span', {
    staticClass: "fa fa-times text-danger"
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.errors.has('PrimaryEmail')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('PrimaryEmail')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Secondary email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.secondaryEmail),
      expression: "newUser.secondaryEmail"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('SecondaryEmail')
    },
    attrs: {
      "type": "text",
      "name": "SecondaryEmail",
      "id": "SecondaryEmail",
      "placeholder": "Secondary Email"
    },
    domProps: {
      "value": (_vm.newUser.secondaryEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.secondaryEmail = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('SecondaryEmail')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('SecondaryEmail')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.primaryPhoneNum),
      expression: "newUser.primaryPhoneNum"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('primaryPhoneNum')
    },
    attrs: {
      "id": "primaryPhoneNum",
      "name": "primaryPhoneNum",
      "placeholder": "Phone number"
    },
    domProps: {
      "value": (_vm.newUser.primaryPhoneNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.primaryPhoneNum = $event.target.value
      }, _vm.onPhoneNumberChange]
    }
  }), _vm._v(" "), (_vm.errors.has('primaryPhoneNum')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ssn"
    }
  }, [_vm._v("Secondary phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.secondaryPhoneNum),
      expression: "newUser.secondaryPhoneNum"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "spn"
    },
    domProps: {
      "value": (_vm.newUser.secondaryPhoneNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.secondaryPhoneNum = $event.target.value
      }, _vm.onPhoneNumberChange]
    }
  })])])]), _vm._v(" "), (_vm.enableMfa) ? _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mfaPhonePreference),
      expression: "mfaPhonePreference"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mfaPhonePreference"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mfaPhonePreference = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("-- Select --")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PRIMARY",
      "disabled": !_vm.hasPrimaryPhone
    }
  }, [_vm._v("\n                    Primary Phone\n                  ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SECONDARY",
      "disabled": !_vm.hasSecondaryPhone
    }
  }, [_vm._v("\n                    Secondary Phone\n                  ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NONE"
    }
  }, [_vm._v("None (Email only)")])]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                  Select which phone number should be used for SMS multi-factor authentication.\n                ")])])])]) : _vm._e(), _vm._v(" "), (_vm.showProvideLoginOption) ? _c('div', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', {
    staticClass: "dark-grey-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provideInvestorLogin),
      expression: "provideInvestorLogin"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "provide-investor-login",
      "disabled": _vm.emailIsInvalid
    },
    domProps: {
      "checked": Array.isArray(_vm.provideInvestorLogin) ? _vm._i(_vm.provideInvestorLogin, "") > -1 : (_vm.provideInvestorLogin)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.provideInvestorLogin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.provideInvestorLogin = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.provideInvestorLogin = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.provideInvestorLogin = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n              Provide investor log in\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', {
    staticClass: "dark-grey-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableMfa),
      expression: "enableMfa"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "enable-mfa",
      "disabled": !_vm.provideInvestorLogin
    },
    domProps: {
      "checked": Array.isArray(_vm.enableMfa) ? _vm._i(_vm.enableMfa, "") > -1 : (_vm.enableMfa)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.enableMfa,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.enableMfa = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.enableMfa = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.enableMfa = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n              Enable MFA\n            ")])]), _vm._v(" "), (_vm.showLoginNotice) ? _c('div', {
    staticClass: "panel-body account-notice"
  }, [_vm._m(10)]) : _vm._e(), _vm._v(" "), (_vm.newUser.userType === 'INVESTOR' || _vm.newUser.userType === 'ADVISOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY') ? _c('div', [(_vm.newUser.userType == 'INVESTOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY') ? _c('div', {
    staticClass: "panel-title"
  }, [_vm._v(" Residential Address ")]) : _vm._e(), _vm._v(" "), (_vm.newUser.userType == 'ADVISOR') ? _c('div', {
    staticClass: "panel-title"
  }, [_vm._v(" Business Address ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  })]) : _vm._e(), _vm._v(" "), (_vm.newUser.userType === 'INVESTOR' || _vm.newUser.userType === 'ADVISOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('RestrictedTwoInputs', {
    attrs: {
      "instructionsLabel": "Make sure your address doesn't exceed 50 characters.",
      "id": "ResidentialAddress",
      "fieldLabel": _vm.streetAddressLabel,
      "primaryPlaceholder": "Street and number e.g. 123 Any Street",
      "secondaryPlaceholder": "(optional) Apartment, building, floor, etc.",
      "dual": true,
      "primaryInput": _vm.newUser.residentialAddress.streetAddress1,
      "secondaryInput": _vm.newUser.residentialAddress.streetAddress2
    },
    on: {
      "inputUpdated": _vm.residentialAddressUpdated
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.newUser.userType === 'INVESTOR' || _vm.newUser.userType === 'ADVISOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "zip-code"
    }
  }, [_vm._v("Zip code "), (!_vm.isInstitutionalRepresentative) ? _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.residentialAddress.zipCode),
      expression: "newUser.residentialAddress.zipCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && _vm.newUser.userType !== 'READ_ONLY'
      }),
      expression: "{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('Zipcode') || _vm.isZipCodeInvalid(_vm.newUser.residentialAddress.zipCode, _vm.newUser.residentialAddress.country)
    },
    attrs: {
      "type": "text",
      "name": "Zipcode",
      "id": "Zipcode",
      "placeholder": "Zip code"
    },
    domProps: {
      "value": (_vm.newUser.residentialAddress.zipCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.residentialAddress.zipCode = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('Zipcode') || _vm.isZipCodeInvalid(_vm.newUser.residentialAddress.zipCode, _vm.newUser.residentialAddress.country)) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City "), (!_vm.isInstitutionalRepresentative) ? _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.residentialAddress.city),
      expression: "newUser.residentialAddress.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && _vm.newUser.userType !== 'READ_ONLY'
      }),
      expression: "{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('City')
    },
    attrs: {
      "type": "text",
      "name": "City",
      "id": "City",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.newUser.residentialAddress.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.residentialAddress.city = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('City')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v("State "), (!_vm.isInstitutionalRepresentative && _vm.selectedUserType !== 'READ_ONLY') ? _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.residentialAddress.state),
      expression: "newUser.residentialAddress.state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && _vm.newUser.userType !== 'READ_ONLY'
      }),
      expression: "{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('ResidentialState')
    },
    attrs: {
      "id": "ResidentialState",
      "name": "ResidentialState",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newUser.residentialAddress.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _vm._l((_vm.countryStates('residentialAddress')), function(s) {
    return _c('option', {
      domProps: {
        "value": s.abbreviation
      }
    }, [_vm._v(_vm._s(s.name))])
  })], 2), _vm._v(" "), (_vm.errors.has('ResidentialState')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v("Country "), (!_vm.isInstitutionalRepresentative && _vm.selectedUserType !== 'READ_ONLY') ? _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.residentialAddress.country),
      expression: "newUser.residentialAddress.country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && _vm.newUser.userType !== 'READ_ONLY'
      }),
      expression: "{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('ResidentialCountry')
    },
    attrs: {
      "id": "ResidentialCountry",
      "name": "ResidentialCountry",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newUser.residentialAddress.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _vm._l((_vm.geoLocation.countries), function(c) {
    return _c('option', {
      domProps: {
        "value": c.abbreviation
      }
    }, [_vm._v(_vm._s(c.name))])
  })], 2), _vm._v(" "), (_vm.errors.has('ResidentialCountry')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.newUser.userType == 'INVESTOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType == 'ADVISOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY') ? _c('fieldset', {
    staticClass: "checkbox c-checkbox check-margin mt-xl mb-lg"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isResidentDefaultAddress),
      expression: "isResidentDefaultAddress"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "isResidentDefaultAddress"
    },
    domProps: {
      "checked": Array.isArray(_vm.isResidentDefaultAddress) ? _vm._i(_vm.isResidentDefaultAddress, "") > -1 : (_vm.isResidentDefaultAddress)
    },
    on: {
      "click": function($event) {
        _vm.submitDifferentMailingAddress()
      },
      "__c": function($event) {
        var $$a = _vm.isResidentDefaultAddress,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isResidentDefaultAddress = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isResidentDefaultAddress = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isResidentDefaultAddress = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("Different mailing address\n            ")])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "mailing-address mb-xl",
    attrs: {
      "hidden": !_vm.isResidentDefaultAddress
    }
  }, [(_vm.newUser.userType == 'INVESTOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType == 'ADVISOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY') ? _c('div', [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Mailing Address")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  })]) : _vm._e(), _vm._v(" "), (_vm.newUser.userType === 'INVESTOR' || _vm.newUser.userType === 'ADVISOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 top-margin"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('RestrictedTwoInputs', {
    attrs: {
      "instructionsLabel": "Make sure your address doesn't exceed 50 characters.",
      "id": "MailinglAddress",
      "fieldLabel": _vm.streetAddressLabel,
      "primaryPlaceholder": "Street and number e.g. 123 Any Street",
      "secondaryPlaceholder": "(optional) Apartment, building, floor, etc.",
      "dual": true,
      "primaryInput": _vm.newUser.mailingAddress.streetAddress1,
      "secondaryInput": _vm.newUser.mailingAddress.streetAddress2,
      "isDisabled": !_vm.isResidentDefaultAddress
    },
    on: {
      "inputUpdated": _vm.mailingAddressUpdated
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.newUser.userType === 'INVESTOR' || _vm.newUser.userType === 'ADVISOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.mailingAddress.zipCode),
      expression: "newUser.mailingAddress.zipCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && _vm.newUser.userType !== 'READ_ONLY'
      }),
      expression: "{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.isResidentDefaultAddress && (_vm.errors.has('MailingZipcode') || _vm.isZipCodeInvalid(_vm.newUser.mailingAddress.zipCode, _vm.newUser.mailingAddress.country))
    },
    attrs: {
      "type": "text",
      "name": "MailingZipcode",
      "id": "MailingZipcode",
      "placeholder": "Zip code",
      "disabled": !_vm.isResidentDefaultAddress
    },
    domProps: {
      "value": (_vm.newUser.mailingAddress.zipCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.mailingAddress.zipCode = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isResidentDefaultAddress && (_vm.errors.has('MailingZipcode') || _vm.isZipCodeInvalid(_vm.newUser.mailingAddress.zipCode, _vm.newUser.mailingAddress.country))) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.mailingAddress.city),
      expression: "newUser.mailingAddress.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && _vm.newUser.userType !== 'READ_ONLY'
      }),
      expression: "{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.isResidentDefaultAddress && _vm.errors.has('MailingCity')
    },
    attrs: {
      "type": "text",
      "name": "MailingCity",
      "id": "MailingCity",
      "placeholder": "City",
      "disabled": !_vm.isResidentDefaultAddress
    },
    domProps: {
      "value": (_vm.newUser.mailingAddress.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.mailingAddress.city = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isResidentDefaultAddress && _vm.errors.has('MailingCity')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.mailingAddress.state),
      expression: "newUser.mailingAddress.state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && _vm.newUser.userType !== 'READ_ONLY'
      }),
      expression: "{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}"
    }],
    class: {
      'form-control ': true, 'form-control-error': _vm.isResidentDefaultAddress && _vm.errors.has('MailingState'), 'disabled-state': !_vm.isResidentDefaultAddress
    },
    attrs: {
      "id": "MailingState",
      "name": "MailingState",
      "disabled": !_vm.isResidentDefaultAddress,
      "required": "",
      "disabled": !_vm.isResidentDefaultAddress
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newUser.mailingAddress.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _vm._l((_vm.countryStates('mailingAddress')), function(s) {
    return _c('option', {
      domProps: {
        "value": s.abbreviation
      }
    }, [_vm._v(_vm._s(s.name))])
  })], 2), _vm._v(" "), (_vm.isResidentDefaultAddress && _vm.errors.has('MailingState')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(14), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.mailingAddress.country),
      expression: "newUser.mailingAddress.country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && _vm.newUser.userType !== 'READ_ONLY'
      }),
      expression: "{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('MailingCountry')
    },
    attrs: {
      "id": "MailingCountry",
      "name": "MailingCountry",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newUser.mailingAddress.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _vm._l((_vm.geoLocation.countries), function(c) {
    return _c('option', {
      domProps: {
        "value": c.abbreviation
      }
    }, [_vm._v(_vm._s(c.name))])
  })], 2), _vm._v(" "), (_vm.errors.has('MailingCountry')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), (_vm.newUser.userType === 'INVESTOR' || _vm.newUser.userType === 'MINOR') ? _c('div', [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-container",
    class: {
      'has-error': _vm.isFileInvalid
    }
  }, [_c('div', {
    staticClass: "bottom-margin"
  }, [_c('input', {
    ref: "fileupload",
    staticClass: "form-control filestyle",
    staticStyle: {
      "position": "absolute",
      "clip": "rect(0px 0px 0px 0px)"
    },
    attrs: {
      "type": "file",
      "data-classbutton": "btn btn-default",
      "data-classinput": "form-control inline",
      "id": "filestyle-0",
      "tabindex": "-1",
      "accept": _vm.getAcceptedFileExtensions()
    },
    on: {
      "change": _vm.fileChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bootstrap-filestyle input-group"
  }, [_c('input', {
    staticClass: "form-control ",
    attrs: {
      "type": "text",
      "placeholder": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.selectedFile ? _vm.selectedFile.name : ''
    }
  }), _vm._v(" "), _vm._m(16)])]), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Your file must be in JPG, JPEG, PNG, TIF or PDF format and cannot exceed 10MB.")]), _vm._v(" "), (_vm.isFileInvalid) ? _c('span', {
    staticClass: "help-block m-b-none"
  }, [_vm._v("The file you selected is not valid. Please select a different file.")]) : _vm._e()]), _vm._v(" "), _vm._m(17), _vm._v(" "), (_vm.uploadedFiles.length > 0) ? _c('div', {
    staticClass: "space table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-files"
  }, [_vm._m(18), _vm._v(" "), _c('tbody', _vm._l((_vm.uploadedFiles), function(file, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(new Date())))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      staticClass: "text-red",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeDocument(index)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-trash"
    })])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "space"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.newUser.userType == 'INVESTOR' || _vm.newUser.userType === 'MINOR') ? _c('div', [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(20), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.paymentPreference),
      expression: "newUser.paymentPreference"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('paymentPreference')
    },
    attrs: {
      "name": "paymentPreference",
      "id": "paymentPreference",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newUser.paymentPreference = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Select principal payment preference")]), _vm._v(" "), _vm._l((_vm.paymentPreferences), function(principal) {
    return _c('option', {
      key: principal.id,
      domProps: {
        "value": principal.name
      }
    }, [_vm._v(_vm._s(principal.text))])
  })], 2), _vm._v(" "), (_vm.errors.has('paymentPreference')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(21), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.interestPreference),
      expression: "newUser.interestPreference"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('interestPreference')
    },
    attrs: {
      "name": "interestPreference",
      "id": "interestPreference",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newUser.interestPreference = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Select interest payment preference")]), _vm._v(" "), _vm._l((_vm.paymentPreferences), function(interest) {
    return _c('option', {
      key: interest.id,
      domProps: {
        "value": interest.name
      }
    }, [_vm._v(_vm._s(interest.text))])
  })], 2), _vm._v(" "), (_vm.errors.has('interestPreference')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmitButton()
    },
    on: {
      "click": function($event) {
        _vm.validateAndSubmitUser()
      }
    }
  }, [_vm._v("Submit")])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-back icon-back top-margin bottom-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Go back")])])])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Create user\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "icon-exclamation pr-sm"
  }), _vm._v("There was an issue validating your personal information.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]), _c('small', [_vm._v(" Required fields")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("First name "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Last name "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Company name 1 "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Email "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "primaryPhoneNum"
    }
  }, [_vm._v("Primary phone number "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "mfaPhonePreference"
    }
  }, [_c('strong', [_vm._v("MFA Phone Preference")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info alert-dismissible mt-lg",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("\n                Normally we do NOT provide minors with a log in.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "zip-code"
    }
  }, [_vm._v("Zip code "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v("State "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v("Country "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-title"
  }, [_c('div', [_vm._v("KYC documentation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "group-span-filestyle input-group-btn",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('label', {
    staticClass: "btn btn-default document-label",
    attrs: {
      "for": "filestyle-0"
    }
  }, [_c('span', {
    staticClass: "icon-span-filestyle fa fa-folder-open"
  }), _vm._v(" "), _c('span', {
    staticClass: "buttonText"
  }, [_vm._v("Choose file")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "panel-list mt-lg text-muted"
  }, [_c('li', [_vm._v("Ensure the document has not expired.")]), _vm._v(" "), _c('li', [_vm._v("The document should not look fuzzy or cropped.")]), _vm._v(" "), _c('li', [_vm._v("Make sure the name and address match the profile information.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("File name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Uploaded by")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-title space"
  }, [_c('div', [_vm._v("Payment preference")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v("Principal maturity preference "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v("Interest payment preference "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2801cb1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCreationByAdmin.vue
// module id = 2127
// module chunks = 1